<template>
  <slot v-bind="{ onSuccess }"></slot>
</template>

<script>
import { mapStores } from 'pinia'
import useBcDocumentStore from '@/frontapp/store/bcDocument'

export default {
  computed: {
    ...mapStores(useBcDocumentStore),
  },
  methods: {
    onSuccess (payload) {
      if (payload.$controls['approvalForm'].documentRev.id !== this.bcDocumentStore.documentRev) {
        // have to reload document
        //const documentReloaded = this.bcDocumentStore.willLoadDocument(this.bcDocumentStore.document.id)
        this.bcDocumentStore.willChangeRevision = true
        this.$router.replace({ 
          name: 'BCDocumentDetailRev',
          params: { revId: payload.$controls['approvalForm'].documentRev.id } 
        })
        //await documentReloaded
      
      } else {
        this.bcDocumentStore.document.approval = payload.$controls['approvalForm'].approval
      }
    }
  }
}
</script>
